<template>
  <CheckboxComponent class="field-checkbox" v-model="comp" v-bind="$attrs" />
</template>

<script>
import { CheckboxComponent } from 'vue-elder-checkbox'
import { ValueComp } from '../utils'

export default {
  props: {
    value: Boolean,
    default: Boolean,
  },
  computed: {
    comp: ValueComp(),
  },
  created() {
    let hasDefaultProp = 'default' in this.$options.propsData
    if (hasDefaultProp && this.value === undefined) this.comp = this.default
  },
  components: {
    CheckboxComponent,
  },
}
</script>
